import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, maxLength: number = 20): string {
    if (!value || value.length <= maxLength) {
      return value;
    }
    const start = value.substring(0, Math.floor(maxLength / 2));
    const end = value.substring(value.length - Math.ceil(maxLength / 2));
    return `${start}...${end}`;
  }
}
